import { Row, Col, Button, Breadcrumb, Divider, Form, message } from "antd";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import TillNumbers from "./TillNumber";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { useMutation } from "react-query";
import { Denomination, getCurrencyDenomination } from "../../api/TillStats";
import { createContext } from "react";
import {
  bulkAddTillDetails,
  bulkEditTillDetails,
  getTillDetails,
} from "../../api/till";
import { stat } from "fs";

export const statesContext = createContext<any>(null);
interface DetailsType {
  denominationId: number;
  amount: number;
}
const Till = () => {
  const { state } = useLocation();
  const [value, setValue] = useState(state?.value ? state?.value : "LBP");
  const [TillData, setTillData] = useState<[] | undefined>(undefined);
  const [details, setDetails] = useState<[]>([]);
  const [states, setStates] = useState<{
    tillDetails: Denomination[];
  }>({ tillDetails: [] });
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const tillId = Number(useParams().id);
  const navigate = useNavigate();

  const {
    mutateAsync: CurrencyDenominationMutation,
    isLoading: isCurrencyDenominationLoading,
  } = useMutation("getCurrencyDenomination", getCurrencyDenomination);
  const {
    mutateAsync: getTillDetailsMutation,
    isLoading: isTillDetailsLoading,
  } = useMutation("getCurrencyDenomination", () => getTillDetails(tillId), {
    onSuccess: (res) => {
      setStates({
        tillDetails: [
          ...res.data.currencyDenomination
            .flatMap((c: any) => c.denomination)
            .map((d: any) => {
              return { denominationId: d.id, amount: d.quantity };
            }),
        ],
      });

      setDetails(
        res.data.currencyDenomination.flatMap(
          (currency: any) => currency?.denomination
        )
      );
    },
  });

  useEffect(() => {
    CurrencyDenominationMutation().then((res: any) => {
      setTillData(res.data);
    });
    getTillDetailsMutation();
  }, [CurrencyDenominationMutation, getTillDetailsMutation]);

  const filterData = TillData?.filter(
    (item: any) => item?.curr?.abbreviation === value
  ) as [];
  interface ErrorResponse {
    response: {
      data: {
        message: string;
      };
    };
  }

  const { mutateAsync: addTillDetailsMutation } = useMutation(
    "createBulkTill",
    () => {
      return bulkAddTillDetails(tillId, {
        tillDetails: states.tillDetails.filter(
          (state: any) => state.amount > 0
        ),
      });
    },
    {
      onSuccess: (res) => {},
      onError: (err: ErrorResponse) => {
        message.error(err?.response?.data.message);
      },
    }
  );
  const { mutateAsync: editTillDetailsMutation } = useMutation(
    "editBulkTill",
    () => {
      return bulkEditTillDetails(tillId, {
        tillDetails: states.tillDetails.filter(
          (state: any) => state.amount > 0
        ),
      });
    },
    {
      onSuccess: (res) => {},
      onError: (err: ErrorResponse) => {
        message.error(err?.response?.data.message);
      },
    }
  );
  return (
    <statesContext.Provider value={{ states: states, setStates: setStates }}>
      <Row>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <>{t("home")}</>,
              },
              {
                title: <>{t("till-information")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("edit-till-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Row style={{ width: "100%", marginTop: "20px" }}>
        <Col offset={1} span={22} style={{ display: "flex" }}>
          <Button
            style={{ background: "none", boxShadow: "none" }}
            type="text"
            className={value === "LBP" ? "selected" : ""}
            onClick={() => {
              setValue("LBP");
            }}
          >
            {t("lebanese-pound-l.l")}
          </Button>
          <Col>
            <Button
              style={{ background: "none", boxShadow: "none" }}
              type="text"
              className={value === "USD" ? "selected" : ""}
              onClick={() => {
                setValue("USD");
              }}
            >
              {t("american-dollar-$")}
            </Button>
          </Col>
        </Col>
        <Col offset={1} span={22}>
          <Divider style={{ borderColor: "#D9D9D9" }} />
        </Col>
      </Row>
      <Row>
        <Col span={22}>
          <Col offset={1} style={{ width: "100%" }}>
            <TillNumbers
              TillData={filterData}
              setTillData={setTillData}
              CurrencyDenominationMutation={CurrencyDenominationMutation}
              isCurrencyDenominationLoading={isCurrencyDenominationLoading}
              form={form}
              details={details}
            />
          </Col>
        </Col>
      </Row>
      <Row
        style={{
          marginTop: "10vh",
        }}
      >
        <Col offset={1}>
          <CancelBtn />
        </Col>

        <Col
          offset={16}
          span={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Col>
            <Button
              style={{
                background: "#1677FF",
                color: "#fff",
                height: "40px",
                width: "140px",
              }}
              size="large"
              onClick={() => {
                form.submit();
                !state.isEdit
                  ? addTillDetailsMutation().then(() => {
                      navigate("/main");
                    })
                  : editTillDetailsMutation().then(() => {
                      navigate("/information");
                    });

                // setOpen(true);
                // navigate("/main");
              }}
            >
              {t("save")}
            </Button>
          </Col>
        </Col>
      </Row>
      <AddEditModal
        form="warehouseform"
        open={open}
        setOpen={setOpen}
        name={<span>{""}</span>}
        title={`${t("")}`}
      />
    </statesContext.Provider>
  );
};

export default Till;
